<template>
  <div class="">
    <div class="drag_verify" :style="dragVerifyStyle" @mousemove="dragMoving" @mouseup="dragFinish(pastClass)"
         @touchmove="dragMoving" @touchend="dragFinish(pastClass)">
      <div class="dv_progress_bar" ref="progressBar" :style="progressBarStyle"></div>
      <div class="dv_text shine" :style="textStyle" ref="message">{{message}}</div>
      <div @click="request = true" class="dv_handler dv_handler_bg" @mousedown="dragStart"  ref="handler"
           :style="handlerStyle" @touchstart="dragStart">
        <v-icon :class="handlerIcon">{{ show ? 'keyboard_arrow_left' : 'fas fa-arrow-right' }}</v-icon>
      </div>
    </div>
    <div>
      <v-dialog class="pa-0 card-r no-shadow" v-model="request" width="700">
        <v-card class="card-r no-shadow grey lighten-3">
          <v-layout row xs12 justify-center>
            <v-flex xs12>
              <v-layout wrap>
                <v-flex xs12 class=" ma-2">
                  <v-btn @click="request = false" class="transparent" style="position: absolute ; top: 0px; right: 0"
                         icon small>
                    <v-icon class="text-grey">
                      close
                    </v-icon>
                  </v-btn>
                  <div class="text-sm-left f-20 pl-2 text-capitalize" color="#002d4a"  >Class details</div>
                </v-flex>
                <v-divider></v-divider>
              </v-layout>
              <v-container fluid grid-list-xl>
                <v-layout row wrap class="">
                  <v-flex v-if="alertType">
                    <v-alert
                      :value="true"
                      color="success"
                      icon="check_circle"
                      outline
                      v-if="alertType=='success'"
                    >
                      {{msg}}
                    </v-alert>
                    <v-alert
                      :value="true"
                      color="error"
                      icon="warning"
                      outline
                      v-if="alertType=='warning'"
                    >
                      {{msg}}
                    </v-alert>
                  </v-flex>
                  <v-flex xs7 class="mb-0 pb-0">
                    <v-text-field outline class="mb-0 pb-0"
                                  v-model="selectedRequest.date"
                                  label="Date"
                                  placeholder="Date"
                    ></v-text-field>
                  </v-flex>
                  <!-- <v-flex xs5>
                    <v-text-field outline class="mb-0 pb-0"
                                  v-model="selectedRequest.time"
                                  label="Time"
                                  placeholder="Time"
                                  v-on="on"
                    ></v-text-field>
                  </v-flex> -->
                  <v-flex xs5>
                    <v-flex class="w-100 white word-break">
                      <!-- <vue-timepicker format="HH:mm:ss" :time-value.sync="selectedRequest.Times" v-model="selectedRequest.Times" minute-interval="0" second-interval="0" ></vue-timepicker> -->
                      <timeComp :time="selectedRequest.Times" v-on:my-event="setTime($event)"></timeComp>
                    </v-flex>
                  </v-flex>
                  <v-flex xs12>
                    <v-textarea
                      outline
                      class="mb-0 pb-0"
                      name="input-7-4"
                      label="Description"
                      placeholder="Description"
                      v-model="selectedRequest.description"
                      value="The Woodman set to work at once, and so sharp was his axe that the tree was soon chopped nearly through."
                    ></v-textarea>
                  </v-flex>
                  <v-flex d-flex lg4   xs12 class="pt-0 mt-0">
                    <v-btn @click="signTrue(selectedRequest.item)" v-if="!loading" larg depressed class="no-shadow card-r" color="primary">Accept</v-btn>
                  </v-flex>
                  <v-flex class="text-xs-center pa-0" xs12 sm12 lg9 style="margin:auto">
                    <pulse-loader :loading="loading" :color="'#004d98'"></pulse-loader>
                  </v-flex>
                </v-layout>
              </v-container>
            </v-flex>
          </v-layout>
        </v-card>
      </v-dialog>
    </div>
  </div>


</template>
<script>
  /* eslint-disable */
  export default {
    props: {
      pastClass:'',
      request_status:'',
      width: {
        type: Number,
        default: 100
      },
      height: {
        type: Number,
        default: 50
      },
      text: {
        type: String,
        default: 'Swipe to Finish'
      },
      alreadyBooked: {
        type: String,
        default: 'Request already sent'
      },
      successText: {
        type: String,
        default: 'completed'
      },
      background: {
        type: String,
        default: '#ccc'
      },
      progressBarBg: {
        type: String,
        default: '#9E9E9E'
      },
      completedBg: {
        type: String,
        default: '#0068bc '
      },
      circle: {
        type: Boolean,
        default: true
      },
      handlerIcon: {
        type: String,
        default: 'home'
      },
      successIcon: {
        type: String
      },
      handlerBg: {
        type: String,
        default: '#fff'
      },
      textSize: {
        type: String,
        default: '16px'
      },
      textweight: {
        type: String,
        default: 'bold'
      }
    },
    computed:{
      handlerStyle:function(){
        let left
        if(this.request_status==1){
          left=0
        }else{
          left=0
        }
        console.log("left :"+left)
        return {
          left: '0px',
          width : this.height-2+'px',
          height : this.height-2+'px',
          // borderRadius: this.circle?'50%':0,
          background: this.handlerBg,
          left:left+'px'
        }
      },
      message : function(){
        let left
        if(this.request_status==1){
          // return this.isPassing?this.successText:this.alreadyBooked
          return this.isPassing?this.successText:this.text
        }else{
          return this.isPassing?this.successText:this.text
        }
      },
      dragVerifyStyle:function(){
        return {
          width: this.width + '%',
          height : this.height+'px',
          lineHeight: this.height+'px',
          background:this.background,
          borderRadius: this.circle?this.height/2+'px':0
        }
      },
      progressBarStyle: function(){

        return {
          background: this.progressBarBg,
          height : this.height+'px',
          borderRadius: this.circle?this.height/2+'px 0 0 ' + this.height/2+'px':0,
        }
      },
      textStyle: function(){
        return {
          height : this.height+'px',
          width : this.width + '%',
          fontSize:this.textSize,
          fontWeight:this.textweight
        }
      },
      handlerIconClass: function(){
        return this.isPassing?this.handlerIcon:this.successIcon
      }

    },
    data () {
      return {
        show:'',
        request: false,
        isMoving : false,
        ChangeTime: false,
        x:0,
        isPassing : false,
        alertType:'',
        // message:'',
        msg:'',
        requestSubmitPopup:false,
        selectedRequest:''
      }
    },
    mounted:function(){
      this.init()
    },
    created:function(){
      // if(this.request_status==1){
      //   this.$refs.progressBar.style.left = 95
      // }
    },
    methods:{
      emitMethod(){
        this.$emit("emitMethod")
      },
      init: function(){

      },
      submitRequest(selectedRequest){
        let Data={
          student_bookings_id:selectedRequest.booked_id,
          student_sign:'1'
        }
        let self=this
        api.postData('student/student_class/addSignature',Data)
          .then(res=>{
            if(res.status==201){
              self.msg="Successfully confirmed"
              self.alertType="success"
              api.postData('student/view_classes').then(res=>{ self.$store.dispatch('setClasses',res.data) })
            }else{
              self.msg="Failed"
              self.alertType="warning"
            }

          }).catch(err=>{
          self.msg="Failed"
          self.alertType="warning"
          self.$refs.progressBar.style.width = 0 + '%';
          self.$refs.handler.style.left = '0';
        })
        // this.ChangeTime = false
      },
      dragStart: function(e){
        if(!this.isPassing) {
          this.isMoving = true;
          var handler = this.$refs.handler;
          this.x = (e.pageX||e.touches[0].pageX) - parseInt(handler.style.left.replace('%',''), 10);
        }

      },
      dragMoving: function(e){
        if(this.isMoving && !this.isPassing){
          var _x = (e.pageX||e.touches[0].pageX) - this.x;
          var handler = this.$refs.handler;
          if(_x > 0 && _x <= (this.width)){
            handler.style.left = _x + '%';
            this.$refs.progressBar.style.width = (_x+this.height/2);
          }else if(_x > (this.width)){
            handler.style.left = (95 + '%');
            this.$refs.progressBar.style.width = (95 + '%');
            this.passVerify();
          }
        }

      },
      dragFinish: function(e){
        if(this.isMoving && !this.isPassing){
          var _x = (e.pageX || e.changedTouches[0].pageX)- this.x;
          if(_x <(this.width - this.height)){
            this.$refs.handler.style.left = '0';
            this.$refs.progressBar.style.width = '0';
          }
          this.isMoving = false;
        }
        // debugger
        if(this.$refs.progressBar.style.width!='0px'){
          console.log("Hello Popup")
          this.selectedRequest=e
          this.requestSubmitPopup=true
          this.emitMethod()
        }
        // this.sentRequest(this.pastClass.booked_id)

      },
      sentRequest(studentBookingId){
        console.log("studentBookingId")
        console.log(studentBookingId)
        api.postData('student/student_class/sentRequest',{student_bookings_id:studentBookingId})
          .then(res=>{
            if(res.status==201){
              api.postData('student/view_classes')
                .then(res=>{
                  console.log(res)
                  this.$store.dispatch('setClasses',res.data)
                  this.alertType="success"
                  this.msg="Sign request successfully sent"
                })
            }else if(res.status==200){
              console.log(res)
              this.alertType="warning"
              this.msg="Already sent"
            }

          }).catch(err=>{
          console.log("error",err)
          this.isMoving = false
          // this.ChangeTime= false
          this.x=0
          this.isPassing = false
          console.log("warning")
          this.alertType="warning"
          this.msg="Failed to send"
        })
      },
      passVerify: function(){
        this.isPassing = true;
        this.isMoving = false;
        var handler = this.$refs.handler;
        handler.className += ' dv_handler_ok_bg';
        handler.children[0].className = this.successIcon;
        this.$refs.progressBar.style.background = this.completedBg;
        this.$refs.message.style.color = '#fff';
        this.$emit('passcallback');
      }
    },
    components: {
    }
  }
</script>
<style lang="scss" scoped>
  $color: #ffffff;
  /*  .shine {
      position: absolute;
      width: 400px;
      top: 50%;
      height: 60px;
      font-weight: 200;
      text-align: center;
      -webkit-background-clip: text;
      -webkit-text-fill-color: transparent;
      background-color: $color;
      background-image: -webkit-linear-gradient(-45deg, rgb(142, 142, 142) 30%, #ffffff 50%, rgb(180, 180, 180) 70%);
      background-blend-mode: hard-light;
      background-size: 200%;
      -webkit-animation: shine 4s infinite;
    }*/
  data-v-667bf172{
    width: 100%!important;
  }
  @-webkit-keyframes shine {
    from {
      background-position: 150%;
    }

    to {
      background-position: -50%;
    }
  }

  @-webkit-keyframes hover {
    from {
      transform: translateY(-50%);
    }

    to {
      transform: translateY(-75%);
    }
  }

  @-webkit-keyframes hoverSmall {
    from {
      transform: translateY(30%) rotate(45deg);
    }
    to {
      transform: translateY(-10%) rotate(45deg);
    }
  }
  .dv_progress_bar{
    border-radius: 50px!important;
    width: 100%!important;
  }
  .drag_verify .dv_progress_bar{
    transition: background 1s ease-in;
  }
  .dv_handler_ok_bg{
    position: sticky!important;
    left: 98%!important;
  }
  .dv_handler{
    border-radius: 50px!important;
  }
  .drag_verify{
    position: relative;
    text-align: center;

  }
  .drag_verify .dv_handler{
    position: absolute;
    top: 0px;
    left: 0px;
    border: 1px solid #ccc;
    cursor: move;
  }
  /*.drag_verify .dv_handler_bg{*/
  /*-webkit-appearance: none !important;*/
  /*background-position: 0 2px;*/
  /*width: 146px;*/
  /*height: 98px;*/
  /*line-height: 1;*/
  /*display: inline-block;*/
  /*}*/
  .drag_verify .dv_handler_ok_bg{
    /*<!--transform: translate (calc(var(&#45;&#45;i, 0)/var(&#45;&#45;n)*-100% + var(&#45;&#45;tx, 0px)));-->*/
    scroll-behavior: smooth;
    -ms-scroll-snap-type: mandatory;
    /* Forces a snap scroll behavior on your images. */
    -webkit-overflow-scrolling: touch;
    -ms-scroll-snap-points-x: snapInterval(0%, 100%);
    transition: transform 0.3s ease-out;
    /*background: #0051a0 !important;*/
    /*display: none;*/
  }
  .drag_verify .dv_handler i{
    width: 49px;
    height: 49px;
    color: #9E9E9E!important;
    font-size: 1.5rem;
    border-radius: 50px!important;
    font-weight: bold!important;
    -moz-osx-font-smoothing: grayscale;
    -webkit-font-smoothing: antialiased;
  }
  .dv_handler[data-v-e3745e34]{
    border-radius: 50px!important;
  }
  .drag_verify .dv_progress_bar{
    position: absolute;
    height: 34px;
    width: 0px;
    transition: background 2s ease-in;
  }
  .drag_verify .dv_text{
    position: absolute;
    top: 0px;
    color:#ffffff!important;
    -moz-user-select: none;
    -webkit-user-select: none;
    user-select: none;
    -o-user-select:none;
    -ms-user-select:none;
  }
  .v-btn--floating.v-btn--small {
    height: 40px;
    width: 40px !important;
    border-radius: 50px!important;
  }
  // .dv_handler[data-v-58772380]{
  //   border-radius: 50px !important;
  // }
  /*.v-btn--small{*/
  /*width: 104px !important;*/
  /*}*/
</style>



// WEBPACK FOOTER //
// src/components/profile/teacher/TestingCompleteDrg.vue